import mitt from 'mitt';
import { type App } from 'vue';

export const eventBusPlugin = (app: App) => {
  const emitter = mitt();

  app.config.globalProperties.$bus = emitter;
};
